import React from 'react';

import {Select} from '@kit';

import {useCharacter} from '../character-context';
import {ABILITIES, SKILLS} from '../model/abilities';
import {spellHasEffect, toggleActiveSpell} from '../model/active-spells';
import {optionLabel} from '../model/choice-options';
import type {ChooseGroup} from '../model/types';
import {InlineCheck} from './inline-check';

import css from './sheet.module.css';

type Props = {
	spellId: string;
};

const choiceKeys = (group: ChooseGroup): string[] => {
	if (group.type === 'ability') return ABILITIES;
	if (group.type === 'skill') return SKILLS;
	return (group.options || []).map((option) => option.key);
};

export const ActiveSpellToggle: React.FC<Props> = ({spellId}) => {
	const {catalog, state, update} = useCharacter();
	if (!spellHasEffect(catalog, spellId)) return null;
	const active = (state.activeSpells || []).find((spell) => spell.spellId === spellId);
	const choose = catalog.getSpell(spellId)?.choose || [];

	const setChoice = (key: string, value: string | undefined) =>
		update((current) => ({
			activeSpells: (current.activeSpells || []).map((spell) =>
				spell.spellId === spellId
					? {...spell, choices: {...spell.choices, [key]: value ? [value] : []}}
					: spell,
			),
		}));

	return (
		<>
			<InlineCheck
				checked={!!active}
				onChange={() =>
					update((current) => ({
						activeSpells: toggleActiveSpell(current.activeSpells || [], catalog, spellId),
					}))
				}
			>
				Действует
			</InlineCheck>
			{active &&
				choose.map((group) => (
					<Select
						key={group.key}
						className={css.baseSelect}
						placeholder={group.label || 'Выбрать'}
						items={choiceKeys(group).map((key) => ({value: key, label: optionLabel(group, key, catalog)}))}
						value={active.choices?.[group.key]?.[0] ?? null}
						onChange={([value]) => setChoice(group.key, value as string | undefined)}
					/>
				))}
		</>
	);
};
